// extracted by mini-css-extract-plugin
export default {"popoverBody":"N8-k-JRtwG0nRJ1A3zTgLg==","popoverBody--noScroll":"_6H6s5dJCibodhWpq3eiwEg=="};